/*
Composable useShowDashboardSidebar handles the global state of showing
navigation sidebar. The composable is used within the navigation controls.
*/
export const useShowProductDropdown = () => {
  const showProductDropdown = useState('showProductDropdown', () => <boolean>false)

  const toggleshowProductDropdown = () => {
    showProductDropdown.value = !showProductDropdown.value
  }

  const showProductDropdownVisible = () => {
    showProductDropdown.value = true
  }

  const setSidebarHidden = () => {
    showProductDropdown.value = false
  }

  return { showProductDropdown, toggleshowProductDropdown, showProductDropdownVisible, setSidebarHidden }
}
